export default __webpack_public_path__ + "static/media/ic_diners_club.693893b9.svg";